// Module
var code = "<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m24.44 42.45-22.71-22.71c-1.56-1.56-1.56-4.09 0-5.66 1.56-1.56 4.09-1.56 5.66 0l17.05 17.05 16.27-16.27c1.56-1.56 4.09-1.56 5.66 0 1.56 1.56 1.56 4.09 0 5.66z\"/></svg>";
// Exports
module.exports = code;